


import React, { useState, useEffect } from "react";
import "./sidebar.css";
import logo from "../components/logo192.png"
import { Link, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTachometerAlt,
  FaUsers,
  FaLayerGroup,
  FaBolt,
  FaCalendarAlt,
  FaExchangeAlt,
  FaUserTie,
  FaSignOutAlt,
  FaCar,
  FaMoneyBill,
  FaFileAlt,
  FaChevronDown,
  FaUserCircle,
} from "react-icons/fa";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarVisible, setIsSidebarVisible] = useState(window.innerWidth > 768);

  const location = useLocation();

  /* ================= ROLE ================= */
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const role = user.role; // admin | tmstaff | mstaff | tstaff

  const isAdmin = role === "admin";
  const isTMStaff = role === "tmstaff";
  const isMStaff = role === "mstaff";
  const isTStaff = role === "tstaff";

  const canSeeAll = isAdmin || isTMStaff || isMStaff;

  /* ================= ORG ================= */
  const orgName = "Bodhimaram Play School";
  const orgLogo =
    "https://t4.ftcdn.net/jpg/15/12/04/11/360_F_1512041110_c0NFJDcHLmUJiwfDowzcKUgsPALmbjdD.jpg";

  /* ================= RESPONSIVE ================= */
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setCollapsed(false);
      setIsSidebarVisible(!mobile);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) setIsSidebarVisible(false);
  }, [location.pathname, isMobile]);

  const toggleSidebar = () => {
    if (isMobile) setIsSidebarVisible(!isSidebarVisible);
    else setCollapsed((p) => !p);
  };

  const handleMenuClick = () => {
    if (isMobile) setIsSidebarVisible(false);
  };

  const isActive = (path) => location.pathname === path;

  const sidebarClass = `sidebardata 
    ${!isMobile && collapsed ? "collapsed" : ""}
    ${isMobile && isSidebarVisible ? "mobile-open" : ""}
    ${isMobile && !isSidebarVisible ? "mobile-hidden" : ""}`;

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <>
      <div className="toggle-btn" onClick={toggleSidebar}>
        <FaBars />
      </div>

      <div className={sidebarClass.trim()}>
        {/* <h2 className="sidebar-title">
          <span className="full-title">
            <div className="organization-container">
              <img src={logo} alt="logo" width={150} height={80}/>
              <span className="organization-name">{orgName}</span>
            </div>
          </span>
        </h2> */}

        <ul>
          {/* ===== DASHBOARD ===== */}
          {canSeeAll && (
            <li className={isActive("/dashboard/") ? "active" : ""}>
              <Link to="/dashboard/" onClick={handleMenuClick}>
                <FaTachometerAlt />
                <span>Dashboard</span>
              </Link>
            </li>
          )}

 {/* ===== MY PROFILE ===== */}
<li className={isActive("/dashboard/profile") ? "active" : ""}>
  <Link to="/dashboard/profile" onClick={handleMenuClick}>
    <FaUserCircle />
    <span>My Profile</span>
  </Link>
</li>


          {/* ===== ALL STUDENTS ===== */}
          <li className={isActive("/dashboard/member") ? "active" : ""}>
            <Link to="/dashboard/member" onClick={handleMenuClick}>
              <FaUsers />
              <span>All Students</span>
            </Link>
          </li>

          {/* ===== GROUPS ===== */}
          <li className={isActive("/dashboard/groups") ? "active" : ""}>
            <Link to="/dashboard/groups" onClick={handleMenuClick}>
              <FaLayerGroup />
              <span>Groups</span>
            </Link>
          </li>

          {/* ===== QUICK COLLECT ===== */}
          {canSeeAll && (
            <li className={isActive("/dashboard/quick") ? "active" : ""}>
              <Link to="/dashboard/quick" onClick={handleMenuClick}>
                <FaBolt />
                <span>Quick Collect</span>
              </Link>
            </li>
          )}

          {/* ===== ATTENDANCE ===== */}
          <li className={isActive("/dashboard/fullattend") ? "active" : ""}>
            <Link to="/dashboard/fullattend" onClick={handleMenuClick}>
              <FaCalendarAlt />
              <span>Attendance</span>
            </Link>
          </li>

          {/* ===== TRANSACTIONS ===== */}
          {canSeeAll && (
            <li className={isActive("/dashboard/transactions") ? "active" : ""}>
              <Link to="/dashboard/transactions" onClick={handleMenuClick}>
                <FaExchangeAlt />
                <span>Transactions</span>
              </Link>
            </li>
          )}
          {canSeeAll && (
            <li className={isActive("/dashboard/StaffAttendance") ? "active" : ""}>
              <Link to="/dashboard/StaffAttendance" onClick={handleMenuClick}>
                <FaExchangeAlt />
                <span>StaffAttendance</span>
              </Link>
            </li>
          )}

          {/* ===== REPORTS ===== */}
          {canSeeAll && (
            <li className={reportsOpen ? "active submenu-open" : ""}>
              <div
                className="menu-item"
                onClick={() => setReportsOpen(!reportsOpen)}
              >
                <FaFileAlt />
                <span>Reports</span>
                <FaChevronDown
                  className={`chevron ${reportsOpen ? "rotated" : ""}`}
                />
              </div>
              {reportsOpen && (
                <ul className="submenu">
                  <li>
                    <Link
                      to="/dashboard/reports/cab-report"
                      onClick={handleMenuClick}
                    >
                      Cab Report
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/reports/Student-Attendance"
                      onClick={handleMenuClick}
                    >
                      Student Attendance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/dashboard/reports/expense-Report"
                      onClick={handleMenuClick}
                    >
                      Expense Report
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}

          {/* ===== CAB ===== */}
          {canSeeAll && (
            <li className={isActive("/dashboard/cab") ? "active" : ""}>
              <Link to="/dashboard/cab" onClick={handleMenuClick}>
                <FaCar />
                <span>Cab</span>
              </Link>
            </li>
          )}

          {/* ===== EXPENSE ===== */}
          {canSeeAll && (
            <li className={isActive("/dashboard/expenses") ? "active" : ""}>
              <Link to="/dashboard/expenses" onClick={handleMenuClick}>
                <FaMoneyBill />
                <span>Expense</span>
              </Link>
            </li>
          )}

          {/* ===== STAFF ===== */}
          {canSeeAll && (
            <li className={isActive("/dashboard/staff") ? "active" : ""}>
              <Link to="/dashboard/staff" onClick={handleMenuClick}>
                <FaUserTie />
                <span>Staff</span>
              </Link>
            </li>
          )}

          {/* ===== LOGOUT ===== */}
          <li>
            <div onClick={handleLogout}>
              <FaSignOutAlt />
              <span>Log Out</span>
            </div>
          </li>
        </ul>
      </div>

      {/* ================= MOBILE BOTTOM NAV ================= */}
{isMobile && (
  <div className="mobileBottomBar">

    <div className="mobileNavItem" onClick={toggleSidebar}>
      <FaBars />
      <span>Menu</span>
    </div>

    {canSeeAll && (
      <Link
        to="/dashboard/"
        className={`mobileNavItem ${isActive("/dashboard/") ? "active" : ""}`}
      >
        <FaTachometerAlt />
        <span>Home</span>
      </Link>
    )}

    <Link
      to="/dashboard/member"
      className={`mobileNavItem ${
        isActive("/dashboard/member") ? "active" : ""
      }`}
    >
      <FaUsers />
      <span>Students</span>
    </Link>

    <Link
      to="/dashboard/groups"
      className={`mobileNavItem ${
        isActive("/dashboard/groups") ? "active" : ""
      }`}
    >
      <FaLayerGroup />
      <span>Groups</span>
    </Link>

    <Link
      to="/dashboard/fullattend"
      className={`mobileNavItem ${
        isActive("/dashboard/fullattend") ? "active" : ""
      }`}
    >
      <FaCalendarAlt />
      <span>Attendance</span>
    </Link>

  </div>
)}
    </>
  );
};

export default Sidebar;
